const state = {
  selectedEvent: null,
  eventSelected: {
    identification: "",
    client: {
      shortName: "",
    },
  },
  modalities: [
    { text: "PREGÃO ELETRÔNICO", value: "PE", checked: true },
    { text: "PREGÃO PRESENCIAL", value: "PP", checked: false },
    { text: "ESTIMATIVA", value: "EST", checked: false },
    { text: "CARTA CONVITE", value: "CC", checked: false },
    { text: "DISPENSA ELETRÔNICA", value: "DE", checked: false },
  ],
};

const getters = {
  GET_EVENT_DETAILS: (state) => state.eventSelected,
  GET_EVENT_BREADCRUMB_NAME: (state) =>
    `[${state.eventSelected.alternativeCode}] ${state.eventSelected.client.shortName} :: ${state.eventSelected.identification}`,
  EVENT_CODE: (state) => state.eventSelected.alternativeCode,
  IS_OPEN_CLOSE: (state) => state.eventSelected.isOpenClose,
  CLIENT_NAME: (state) =>
    state.eventSelected.client && state.eventSelected.client.shortName,
  EVENT_IDENTIFICATION: (state) => state.eventSelected.identification,
  GET_EVENT_LINK: (state) => `/event/${state.eventSelected._id}`,
  GET_MODALITIES: (state) => state.modalities,
};
const mutations = {
  SELECT_EVENT: (state, { eventId }) => {
    state.selectedEvent = eventId;
  },
  SET_EVENT_INFO: (state, { eventDetail }) => {
    state.eventSelected = eventDetail;
  },
};
const actions = {
  OPEN_EVENT_TO_ASSOCIATE_ITEMS: ({ commit }, { eventId, route }) => {
    commit("SELECT_EVENT", { eventId });
    route.push({ name: "ItemAssociation", params: { id: eventId } });
  },
  OPEN_EVENT_TO_RESULT: ({ commit }, { eventId, route }) => {
    commit("SELECT_EVENT", { eventId });
    route.push({ name: "EventResult", params: { id: eventId } });
  },
  OPEN_EVENT_TO_QUOTE: ({ commit }, { eventId, route }) => {
    commit("SELECT_EVENT", { eventId });
    route.push({ name: "ItemQuote", params: { id: eventId } });
  },
  OPEN_EVENT: (
    { commit, dispatch },
    { eventId, eventDetail, route, newWindow = false }
  ) => {
    commit("SELECT_EVENT", { eventId });
    commit("SET_EVENT_INFO", { eventDetail });
    if (!newWindow) {
      route.push({ name: "EventDetail", params: { id: eventId } });
    } else {
      const routeData = route.resolve({
        name: "EventDetail",
        params: { id: eventId },
      });
      window.open(routeData.href, "_blank");
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/view/event/state/index.js